import { render, staticRenderFns } from "./VisitorCard.vue?vue&type=template&id=70600d50&scoped=true&"
import script from "./VisitorCard.vue?vue&type=script&lang=js&"
export * from "./VisitorCard.vue?vue&type=script&lang=js&"
import style0 from "./VisitorCard.vue?vue&type=style&index=0&id=70600d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70600d50",
  null
  
)

export default component.exports